<template>
  <div class="comparison-module internet">
    <TransitionNavbar
      @after-enter="showAddressBar = true"
    >
      <Navbar
        v-if="showNavbar"
        @logo-click="logoClick"
      >
        <template #addressBar>
          <TransitionNavbar
            @afterEnter="showView = true"
          >
            <AddressBar
              v-show="showAddressBar"
              :label="addressBar"
              :show-back-button="phase === 'compare'"
              @goBack="logoClick"
            />
          </TransitionNavbar>
        </template>
      </Navbar>
    </TransitionNavbar>

    <router-view
      v-slot="{ Component }"
      @updatePhase="updatePhase"
    >
      <TransitionComparerView
        @enter="animateNavbar"
        @afterEnter="showContent"
      >
        <component :is="Component" />
      </TransitionComparerView>
    </router-view>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue';
import { useWindowBlurTitle } from 'vue-elements/composables/comparison.js';
import Navbar from '../../vue-elements/navbar/Navbar.vue';
import AddressBar from './components/AddressBar.vue';

import TransitionNavbar from '../../vue-elements/transitions/TransitionNavbar.vue';
import TransitionComparerView from '../../vue-elements/transitions/TransitionComparerView.vue';
import { useNavbarTransition } from '../../vue-elements/composables/transition';

const addressFocus = ref(false);
const phase = ref('compare');
const dynamicTitleEnabled = ref(true);
useWindowBlurTitle(dynamicTitleEnabled);

/*
  * Navbar transition
 */
const {
    showNavbar,
    showAddressBar,
    animateNavbar,
    showContent,
} = useNavbarTransition();

const logoClick = () => {
    window.location.href = '/internet';
};

const updatePhase = (newPhase) => {
    phase.value = newPhase;
};

const addressBar = computed(() => (phase.value === 'compare' ? 'Internet vergelijken' : 'We sturen je door naar de provider'));

</script>
